import styled from 'styled-components';

export const ViewControllerRoot = styled.div`
  display: flex;
  justify-content: left;
  border-bottom: 2px solid var(--border-soft);
  padding: 8px 16px 8px 8px;
  gap: 8px;
  min-height: 56px;
`;

export const MenuGroup = styled.div`
  display: flex;
  border-radius: 8px;
  padding: 4px;
  background-color: var(--surface-default);
  width: fit-content;
`;
